import { RADEnvironmentProxy } from 'radpresentation.htmlclient.defaultviewextensions';

// PDO-Typ und Operationsname des serverseitigen Statusuebersicht-Endpunkts.
const NEWCOMER_PD_TYPE        = 'ONV.ONV.Newcomer';
const OP_STATUS_OVERVIEW      = 'GetNewcomerStatusOverview';

/** Kennzahlen eines Landesverbands (Backend-Kontrakt, siehe NewcomerStatusRowDto). */
export interface INewcomerStatusRow {
    landesverbandId:         number;
    name:                    string;
    /** Aktuell = nicht archiviert und nicht lizensiert. */
    aktuell:                 number;
    /** Archiv = archiviert und nicht lizensiert. */
    archiv:                  number;
    /** Bestanden = lizensiert. */
    bestanden:               number;
    /** Newcomer-Registrierungen der letzten 12 Monate. */
    registrierungen12Monate: number;
    /** Unbeantwortete, aktuelle Meldungen. */
    unbeantwortetAktuell:    number;
    /** Unbeantwortete, archivierte Meldungen. */
    unbeantwortetArchiv:     number;
}

/** Backend-Kontrakt: JSON von ONV.ONV.Newcomer.GetNewcomerStatusOverview */
export interface INewcomerStatusOverview {
    generatedAt?: string;
    rows:         INewcomerStatusRow[];
}

/**
 * Ruft die Newcomer-Statusuebersicht je Landesverband ab. Die Auswertung erfolgt
 * landesverbands-uebergreifend (serverseitig unter SuperUserGuard), daher genuegt
 * ein einziger Aufruf fuer alle Tabellen.
 */
export function fetchNewcomerStatusOverview(): JQueryPromise<INewcomerStatusOverview | null> {
    return RADEnvironmentProxy.getInstance().callStaticOperation({
        pdTypeName:        NEWCOMER_PD_TYPE,
        operationName:     OP_STATUS_OVERVIEW,
        operationParameters: [],
        contextParameters: {},
    }).then((result) => parseNewcomerStatusOverview(result?.returnValue));
}

/**
 * Normalisiert den Rueckgabewert der Operation. <c>returnValue</c> ist je nach
 * Serialisierung bereits ein Objekt oder ein JSON-String.
 */
export function parseNewcomerStatusOverview(returnValue: unknown): INewcomerStatusOverview | null {
    let raw: unknown = returnValue;

    if (typeof raw === 'string') {
        try { raw = JSON.parse(raw); }
        catch { return null; }
    }

    if (raw == null || typeof raw !== 'object') return null;
    const obj = raw as INewcomerStatusOverview;
    if (!Array.isArray(obj.rows)) return null;
    return obj;
}
